export const errorBoundary = {
  errorBoundaryAPPMessage1: "¡Vaya! Algo ha salido mal",
  errorBoundaryAPPMessage2: "Lo estamos solucionando, por favor, intente recargar la página",

  errorBoundaryRedirect1: "¡Vaya! Algo ha salido mal",
  errorBoundaryRedirect2: "Lo estamos solucionando, haz clic en el botón para volver",

  errorBoundaryHandler1: "¡Vaya! Algo ha salido mal",
  errorBoundaryHandler2: "Intente recargar esta sección",

  errorBoundaryBtnReload: "Recargar",
  errorBoundaryBtnHome: "Volver",
};
